import styled, { keyframes } from 'styled-components'

import { Div } from './Div'

const placeHolderShimmer = keyframes`
  0% { background-position: -400px 0  } 100% { background-position: 400px 0  }
`

export const PreloadDiv = styled(Div)`
  /* Animation effect */
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeHolderShimmer};
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #efefef 8%, #eaeaea 18%, #efefef 33%);
  background-size: 800px 104px;
`
